var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"battery",attrs:{"title":Math.round(_vm.batteryLevel) + '%'}},[_c('span',[_vm._v(_vm._s(Math.round(_vm.batteryLevel) + '%'))]),_c('div',{staticClass:"battery-body"},[_c('div',{staticClass:"battery-level",style:({ width: _vm.batteryLevel + '%', backgroundColor: _vm.batteryColor })})]),_c('div',{staticClass:"battery-tip"})])
}
var staticRenderFns = []

export { render, staticRenderFns }